export default __webpack_public_path__ + "static/media/56.ad899520.png";